import { collection, doc } from 'firebase/firestore';

export const DEFAULT_TENANT_ID = 'tas-ski';

let currentTenantId = DEFAULT_TENANT_ID;

export function getActiveTenantId() {
  return currentTenantId || DEFAULT_TENANT_ID;
}

export function setActiveTenantId(tenantId) {
  currentTenantId = tenantId || DEFAULT_TENANT_ID;
}

/**
 * Returns a Firestore collection reference scoped to the active tenant path:
 * /tenants/{tenantId}/{collectionName}
 */
export function getTenantCollection(db, collectionName, tenantId = DEFAULT_TENANT_ID) {
  return collection(db, 'tenants', tenantId, collectionName);
}

/**
 * Returns a Firestore document reference scoped to the active tenant path:
 * /tenants/{tenantId}/{collectionName}/{docId}
 * Optional subCollectionName and subDocId allow nested subcollections (e.g. profiles/{id}/private/details).
 */
export function getTenantDoc(db, collectionName, docId, subCollectionName, subDocId, tenantId = DEFAULT_TENANT_ID) {
  if (subCollectionName && subDocId) {
    return doc(db, 'tenants', tenantId, collectionName, docId, subCollectionName, subDocId);
  }
  if (subCollectionName) {
    return collection(db, 'tenants', tenantId, collectionName, docId, subCollectionName);
  }
  return doc(db, 'tenants', tenantId, collectionName, docId);
}
